import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../utl/models/Visiable";
import { GroupsState } from "../models/GroupsState";

const setMessageVisiable = (state: GroupsState, action: PayloadAction<Visiable>) => {
    state.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;